
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.567 52.7L9.3 62H4.133l8.267-9.3h5.167zM34 52.7l8.267 9.3h5.166l-8.266-9.3H34z","fill":"#24242E"}}),_c('path',{attrs:{"d":"M2 10.067a6 6 0 016-6h31.533a6 6 0 016 6v36.567a2 2 0 01-2 2H4a2 2 0 01-2-2V10.067z","stroke":"#24242E","stroke-width":"4"}}),_c('path',{attrs:{"d":"M20.033 2a1.5 1.5 0 011.5-1.5H32A1.5 1.5 0 0133.5 2v3.7H20.033V2z","fill":"#000","stroke":"#24242E"}}),_c('circle',{attrs:{"cx":"38.133","cy":"39.267","r":"3.633","fill":"#24242E","stroke":"#24242E"}}),_c('circle',{attrs:{"cx":"12.4","cy":"39.267","r":"3.633","fill":"#24242E","stroke":"#24242E"}}),_c('path',{attrs:{"d":"M2 10.067a6 6 0 016-6h31.533a6 6 0 016 6v19.967H2V10.067z","stroke":"#24242E","stroke-width":"4"}})])
          )
        }
      }
    